export enum ServicesReducerPath {
	ExamsApi = 'examsApi',
	CdaApi = 'cdaApi',
	AIApi = 'aiApi',
	ContactLensesApi = 'contactLensesApi',
	SymptomsApi = 'symptomsApi',
	ReasonsApi = 'reasonsApi',
	CodingApi = 'codingApi',
	InactivityLoginApi = 'inactivityLoginApi',
	SignedPrivacyPolicyDocuments = 'signedPrivacyPolicyDocuments',
	PatientCare = 'patientCare',
}

export enum ServicesEndpointName {
	CheckInactivityLogin = 'checkInactivityLogin',
}

export enum ServicesApiTag {
	Cda = 'cda',
	Ai = 'ai',
	ContactLenses = 'contactLenses',
	Symptoms = 'symptoms',
	Reasons = 'reasons',
	Coding = 'coding',
	SignedPrivacyPolicyDocuments = 'SignedPrivacyPolicyDocuments',
	PatientCare = 'patientCare',
}
